// extracted by mini-css-extract-plugin
export default {"relatedContents":"VOtL6","row":"niYJb","title":"rrNfJ","carousel":"t3vzq"};